import React from 'react';
import styles from './style.css';

const Spinner = (props) => {
    let spinnerProps = {
        style: {
            width: 'var(--cell-size)',
            height: 'var(--cell-size)'
        }
    }
    if(props.size !== undefined){
        spinnerProps.style.width = props.size
        spinnerProps.style.height = props.size
    }
    return (
        <div className={styles.container} {...spinnerProps}>
            <div className={styles.mainSquare}>
                <div className={styles.square1}/>
                <div className={styles.square2}/>
                <div className={styles.square3}/>
                <div className={styles.square4}/>
            </div>
        </div>
    );
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js